import client from "./client.js";

export async function getMemberPermissions(userId) {
  const res = await client.get(`/members/${userId}/permissions`);
  return res.data.data;
}

export async function setPermissionOverride(userId, permission, effect) {
  const res = await client.put(
    `/members/${userId}/permissions/${permission}`,
    { effect }
  );
  return res.data.data;
}

export async function deletePermissionOverride(userId, permission) {
  await client.delete(`/members/${userId}/permissions/${permission}`);
}
